import React from 'react';

// Material ui
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

// Styles
import useStyles from './styles';

interface ReportTitleInterface {
  title: string;
  titleVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  infoIconColor?: string;
  infoIconBgColor?: string;
  tooltipTitle: string;
  classStyle?: string;
}

const ReportTitle: React.FC<ReportTitleInterface> = ({
  title,
  titleVariant = 'h4',
  infoIconColor,
  infoIconBgColor,
  tooltipTitle,
  classStyle,
}) => {
  const classes = useStyles();

  return (
    <Box width='100%' display='flex' alignItems='center'>
      <Typography
        className={classStyle ? classStyle : classes.default}
        variant={titleVariant}>
        {title}
      </Typography>
      <Tooltip title={tooltipTitle} placement='top'>
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          width='1.5rem'
          height='1.5rem'
          bgcolor={infoIconBgColor ? infoIconBgColor : '#000'}
          borderRadius='50%'
          ml='0.25rem'
          pt='0.25rem'>
          <Typography
            style={{
              color: infoIconColor ? infoIconColor : '#fff',
            }}>
            i
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default ReportTitle;
export { ReportTitle };
